const {
  runAllExtenders: baseRunAllExtenders
} = require("vue-extender");

import global from "../global";

const runAllExtenders = (Vue) => {
  baseRunAllExtenders(Vue);

  Vue.defineProperties(Vue.prototype, {
    "GLOBAL": {
      get() {
        return global;
      }
    },
  });
};

export {
  runAllExtenders
};

export default {
  install(Vue) {
    runAllExtenders(Vue);
  }
};



// WEBPACK FOOTER //
// ./src/core/vue-extender/index.js